import { applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import apiMiddleware from './apiMiddleware';
import apiPollingMiddleware from './apiPollingMiddleware';
import notificationsMiddleware from './notificationsMiddleware';
import localStorageMiddleware from './localStorageMiddleware';
import promotionsMiddleware from './promotionsMiddleware';
import tagmanagerMiddleware from './tagmanagerMiddleware';
import userMiddleware from './userMiddleware';

const middleware = applyMiddleware(
  thunk,
  apiMiddleware(),
  apiPollingMiddleware(),
  localStorageMiddleware(),
  notificationsMiddleware(),
  promotionsMiddleware(),
  tagmanagerMiddleware(),
  userMiddleware(),
);

export default middleware;
